import { Trans, useTranslation } from "react-i18next";
import { Language, toLanguage } from "../type";

type FooterLink = {
  i18nKey: string;
  label: string;
  urls: Record<Language, string>;
};

const FOOTER_LINKS: FooterLink[] = [
  {
    i18nKey: "privacyStatement",
    label: "Datenschutzerklärung",
    urls: {
      [Language.EN]: "https://allsafe-group.com/en/privacy-policy",
      [Language.FR]: "https://allsafe-group.com/fr/politique-de-confidentialite",
      [Language.DE]: "https://allsafe-group.com/datenschutzerkl%C3%A4rung",
      [Language.NL]: "https://allsafe-group.com/nl/privacybeleid",
    },
  },
  {
    i18nKey: "cookieSettings",
    label: "Cookie-Einstellungen",
    urls: {
      [Language.EN]: "https://allsafe-group.com/en/#CCM.openWidget",
      [Language.FR]: "https://allsafe-group.com/fr/#CCM.openWidget",
      [Language.DE]: "https://allsafe-group.com/#CCM.openWidget",
      [Language.NL]: "https://allsafe-group.com/nl/#CCM.openWidget",
    },
  },
  {
    i18nKey: "imprint",
    label: "Impressum",
    urls: {
      [Language.EN]: "https://allsafe-group.com/en/imprint",
      [Language.FR]: "https://allsafe-group.com/fr/mentions-l%C3%A9gales",
      [Language.DE]: "https://allsafe-group.com/impressum",
      [Language.NL]: "https://allsafe-group.com/nl/colofon",
    },
  },
  {
    i18nKey: "termsAndConditions",
    label: "AVB",
    urls: {
      [Language.EN]: "https://allsafe-group.com/en/avb",
      [Language.FR]: "https://allsafe-group.com/fr/avb",
      [Language.DE]: "https://allsafe-group.com/avb",
      [Language.NL]: "https://allsafe-group.com/nl/avb",
    },
  },
];

const Footer = () => {
  const { i18n } = useTranslation();
  const language = toLanguage(i18n.resolvedLanguage);
  const copyrightYear = new Date().getFullYear();

  return (
    <footer>
      <div className="bg-allsafe-dark-grey px-3.5 pt-16 pb-6 lg:pt-20">
        <div className="max-w-screen-2xl mx-auto">
          <img
            src="https://allsafe.canto.de/direct/image/blgfnl7gvd2u9dtobuj15laf0e/1ejhWPQb3sgfP1YkRpkGiVpNvdU/original?content-type=image%2Fsvg%2Bxml&name=allsafe_logo_claim_Sicherheit_neg.svg"
            alt="logo"
            className="w-[169.594px] h-[72px]"
          />
          <hr className=" text-allsafe-grey opacity-75 my-6"/>
          <div className="flex items-center justify-between gap-x-8 gap-y-10 flex-wrap md:gap-y-0">
            <ul className="p-0 m-0 flex flex-wrap gap-x-4 max-w-max">
              {FOOTER_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    className="text-gray-200 underline decoration-text-gray-200 text-base leading-6 font-inter-light decoration-2"
                    href={link.urls[language]}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Trans i18nKey={link.i18nKey}>{link.label}</Trans>
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-allsafe-grey-500 text-base leading-6 font-inter-light opacity-75">
              {`© ${copyrightYear} allsafe GmbH & Co. KG`}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
